import { render, staticRenderFns } from "./deleteChargeDetailDialog.vue?vue&type=template&id=8c8834da&scoped=true&"
import script from "./deleteChargeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./deleteChargeDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteChargeDetailDialog.vue?vue&type=style&index=0&id=8c8834da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8834da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c8834da')) {
      api.createRecord('8c8834da', component.options)
    } else {
      api.reload('8c8834da', component.options)
    }
    module.hot.accept("./deleteChargeDetailDialog.vue?vue&type=template&id=8c8834da&scoped=true&", function () {
      api.rerender('8c8834da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue"
export default component.exports